function resolveDeployment(env) {
    const production = env.NODE_ENV === 'production';
    const value = env.REACT_APP_API_URL || (!production && (env.REACT_APP_TEMP_SERVER || env.REACT_APP_SERVER_BASE));
    if (!value) throw new Error('Set REACT_APP_API_URL for this deployment.');
    const api = new URL(value);
    if (api.username || api.password || api.search || api.hash) throw new Error('The API URL must not contain credentials, a query, or a fragment.');
    if (production) {
        if (!env.REACT_APP_PUBLIC_URL) throw new Error('Set REACT_APP_PUBLIC_URL for this customer deployment.');
        const site = new URL(env.REACT_APP_PUBLIC_URL);
        const publicMatch = site.hostname.match(/^([a-z0-9-]+)\.hivequotes\.com$/);
        if (site.protocol !== 'https:' || api.protocol !== 'https:' || site.port || api.port || site.username || site.password || site.pathname !== '/' || site.search || site.hash || api.pathname !== '/') {
            throw new Error('Production URLs must be HTTPS origins without ports, credentials, paths, or query strings.');
        }
        if (!publicMatch || api.hostname !== publicMatch[1] + '-api.hivequotes.com') {
            throw new Error('Customer URLs must pair CUSTOMER.hivequotes.com with CUSTOMER-api.hivequotes.com.');
        }
        return { apiUrl: api.origin, publicUrl: site.origin };
    }
    if (!['http:', 'https:'].includes(api.protocol)) throw new Error('Invalid API protocol.');
    return { apiUrl: value.replace(/\/$/, ''), publicUrl: env.REACT_APP_PUBLIC_URL || '' };
}
module.exports = { resolveDeployment };
